exports.loginEndForWindowsApps=function(sessionUID, username, company){
    window.chrome.webview.postMessage(
        {
            "sessionUID" : sessionUID,
            "username" : username,
            "company" : company
        }
    );
}